import { render } from "./QualityChecks.vue?vue&type=template&id=caf2b7fc"
import script from "./QualityChecks.vue?vue&type=script&lang=js"
export * from "./QualityChecks.vue?vue&type=script&lang=js"

import "./QualityChecks.vue?vue&type=style&index=0&id=caf2b7fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__